// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  
  
  class ReplaceBuddy extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        venue: this.props.venue,
        buddy_details: {
            prev_buddy:'',
            user_id:'',
            mobile_no:'',
            name: '',
            display_name:''
        },
        buddies: [],
        departments_arr:[], 
        role_arr: [],
        game_types: [],
        user_search_list: [],
        temp_list_game: [],
        dialog_open_buddy:true,
        search: false,
        success:false,
        message:'',
        value_set:false
      };
      this.searchUser = this.searchUser.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleUserSubmit = this.handleUserSubmit.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this)
      // this.handleVenueChange = this.handleVenueChange.bind(this)
    }
  
  componentDidMount() {
      this.getAllBuddies();
  }  

  postUpdateBooking(details,venue,props) {
      console.log(details)
      const url = `${getLocationOrigin()}/buddy/replace_buddy/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                        'buddy_details': details,
                                        'venue': venue
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(response=>{  
          console.log('response',response)
          alert(response.message)
          window.location.reload()
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

  getAllBuddies(){
    const url = `${getLocationOrigin()}/cm/get_buddies/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({buddies:data.buddies},()=>{this.setBuddy(data.buddies)});
    }).catch(error => error);
    }

  setBuddy(data){
    var new_value =  Object.assign({}, this.state.buddy_details);
    new_value['prev_buddy'] = data[0].id
    console.log('prev_buddy',data[0].id)
    this.setState({buddy_details: new_value});
  }

  handleChange(event) {
      const name = event.target.name;
      const target = event.target
      const value = target.type === 'checkbox' ? target.checked : target.value
      console.log(name,value)
      var new_value =  Object.assign({}, this.state.buddy_details);

      if (name=="display_name"){
        var temp_no = event.target.value.split(":");
        if (temp_no.length == 2){
             temp_no = temp_no.pop();
            if(temp_no.length != 10){
                new_value[name] = temp_no;
                new_value["mobile_no"] = "";
                new_value["name"] = "";
                new_value["user_id"] = "";
                this.setState({value_set:false})
            }
            else{
                new_value[name] = value
            }
        }
        else{
            new_value[name] = value
        }
      }
      else{
        new_value[name] = value
      }
      this.setState({buddy_details: new_value});
      // this.getAmount(this.state.equipment_details)
  }

  handleSubmit(event) {
      console.log('handle')
      event.preventDefault();
      console.log('Submit');
      if(this.state.buddy_details.user_id){
        this.postUpdateBooking(this.state.buddy_details ,this.state.venue,this.props)
      }
      else{
        alert('Select new buddy first or add one')
      }
    }

  handleUserSubmit(){
    console.log('post');
      
    const url = `${getLocationOrigin()}/eagleeye/add_new_user/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'user_name': this.state.buddy_details.name,
                        'user_mobile': this.state.buddy_details.mobile_no,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
      })
      .then(data => {
        if(data.success){
          var cust = Object.assign([], this.state.buddy_details);
          cust.push({'id': data.user.id, 'name': data.user.name, 'mobile_no':data.user.mobile_no});
          this.setState({user_search_list: cust});
          alert(data.message);
          this.handleClose();
        } else {
          alert(data.message);
        }
       });
    }

    getSearchList(mobile_no) {
      const url = `${getLocationOrigin()}/eagleeye/search_user/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                           'search': mobile_no
                         });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({user_search_list: data.results, search: true}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
    }

    searchUser() {
      {this.state.buddy_details.display_name?this.getSearchList(this.state.buddy_details.display_name):
        alert('Search cannot be blank')}
    }

    setSearch(name, customer_id, mobile_no){
      var new_selected_one =  Object.assign({}, this.state.buddy_details);
      new_selected_one['user_id'] = customer_id
      new_selected_one['mobile_no'] = mobile_no
      new_selected_one['name'] = name
      new_selected_one['display_name'] = `${name}:${mobile_no}`;
      this.setState({buddy_details: new_selected_one, search: false,value_set:true});
    }

    handleClose = () => {
      this.setState({dialog_open_cust:false});
    };
    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }

  
    render() {
      console.log('amount')
      console.log(this.state.buddy_details);
      console.log(this.state.game_arr)

      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleUserSubmit}
        />,
      ];

      return(
        <div style={styles.container}> 

          <div className="row col-md-8 table-bordered" style={styles.table}>
            <div className="col-md-12 label_blue_1" style={styles.main_header}>
               Replace Buddy
            </div>
           
              <form  className="validated-form form-horizontal">

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Select Buddy
                  </div>
                 <select name="prev_buddy" className="col-md-6" style={styles.item_body}
                   onChange={this.handleChange}>
                    {
                       this.state.buddies.map((buddy,index)=>(
                         <option key={buddy.id} value={buddy.id}>{buddy.buddy}</option>
                        ))
                     }
                 </select>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header}  className="col-md-6">
                    Select New Buddy
                  </div>
                  <div className="col-md-6 input-group">
                    <input type="text" name="display_name" className="col-md-8 form-control" value={this.state.buddy_details.display_name}
                      placeholder="Search for buddy"  onChange={this.handleChange} style={{ backgroundColor: this.state.value_set ? '#3CB3E2': 'white'}}/>
                    <span className="input-group-btn">
                      <button className="btn btn-default glyphicon glyphicon-search"
                      type="button" onClick={this.searchUser}></button>
                    </span>
                  </div>
                </div>
                {this.state.search?
              <div className="col-md-12 btn-group">
                {this.state.user_search_list.length?this.state.user_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
            :
            <div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
            <div className="alert alert-danger">Search user not found</div>
            <div>
                <RaisedButton
                  onClick={this.handleOpen}
                  label="Add"
                  style={{float:'right'}}
                  secondary={true}
                />
                <Dialog
                  actions={actions}
                  modal={false}
                  open={this.state.dialog_open_cust}
                  onRequestClose={this.handleClose}
                >
                  <div>
                      <div style={styles.main_header} className="col-md-12">
                          <h3 style={{textAlign:'center'}}>Add New Buddy</h3>
                        </div>
                            <div style={styles.items} className="col-md-12">
                              <div style={styles.item_header} className="col-md-6">
                                Name
                              </div>
                              <input type="text" style={styles.input} name="name" className="required"
                                value={this.state.value} onChange={this.handleChange}/>
                            </div>

                            <div style={styles.items} className="col-md-12">
                              <div style={styles.item_header} className="col-md-6">
                                Mobile No
                              </div>
                            <input type="number" style={styles.input} name="mobile_no" className="required"
                              value={this.state.buddy_details.mobile_no} onChange={this.handleChange}/>
                          </div>
                        </div>
                      </Dialog>
                    
                    </div>

                    </div>
                }</div>:''

              }
             
              <div style={{ padding:'1%', marginLeft:'10px'}}>
                <div style={styles.button_submit} className="col-md-12">
                  <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit}/>
                </div>
              </div>
                
            </form>
          </div>
        </div>
      );
    }
  }
  
  export default ReplaceBuddy;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/replaceBuddy/ReplaceBuddy.js